"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchForm = function SearchForm() {
  return _react.default.createElement("form", null, _react.default.createElement("div", {
    className: "input-field"
  }, _react.default.createElement("input", {
    id: "search",
    type: "search",
    required: true
  }), _react.default.createElement("label", {
    htmlFor: "search"
  }, _react.default.createElement(_Icon.default, null, "search")), _react.default.createElement(_Icon.default, null, "close")));
};

var _default = SearchForm;
exports.default = _default;